export default __webpack_public_path__ + "static/media/productos_iqidi.69e84c7e.pdf";